import { useDeviceType } from '@cian/ui-kit';
import { Welcome } from 'shared/components/Welcome';
import { TWelcomeProps } from 'shared/types/welcome';

type TWelcomeContainer = TWelcomeProps;

export const WelcomeContainer: React.FC<TWelcomeContainer> = ({ onActiveItemId, itemId }) => {
  const device = useDeviceType();

  return <Welcome onActiveItemId={onActiveItemId} itemId={itemId} device={device} />;
};
